import React, { forwardRef } from 'react'

import styled from '@emotion/styled'

type USButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>
const USButton = styled.button<USButtonProps>`
  border: none;
  background: none;
  font-size: inherit;
  font-family: inherit;
  text-align: inherit;
  color: inherit;
  display: inline-block;
  padding: 0;
  margin: 0;
`

/**
 *
 */
const UnstyledButton = forwardRef<HTMLButtonElement, USButtonProps>(
  ({ children, ...rest }, ref) => {
    return (
      <USButton {...rest} ref={ref}>
        {children}
      </USButton>
    )
  },
)

export default UnstyledButton
